import React from 'react';

import { useTypedSelector } from '@/store/store';
import { getShowMoreParams } from '@/store/reducers/cars-stock';
import {
  FiltersWrapper,
  MoreParams,
} from '@/modules/CarsStock/components/common.styles';
import AllParamsButton from '@/modules/CarsStock/components/Mobile/components/AllParamsButton';

import BatteryTypeFilter from './components/BatteryTypeFilter';
import PowerReserveFilter from './components/PowerReserveFilter';
import ElectricEnginesFilter from './components/ElectricEnginesFilter';
import BodyFilter from './components/BodyFilter';
import GearboxFilter from './components/GearboxFilter';
import PriceFilter from './components/PriceFilter';
import WheelFilter from './components/WheelFilter';
import ColorFilter from './components/ColorFilter';
import EngineTypeFilter from './components/EngineTypeFilter';
import EngineCapacityFilter from './components/EngineCapacityFilter';
import SpecialFilter from './components/SpecialFilter';

export function ParamsFilterNew() {
  const isShowMoreParams = useTypedSelector(getShowMoreParams);

  return (
    <React.Fragment>
      <FiltersWrapper>
        <BodyFilter />
        <GearboxFilter />
        <PriceFilter />
      </FiltersWrapper>

      <MoreParams isVisible={isShowMoreParams}>
        <FiltersWrapper>
          <WheelFilter />
          <ColorFilter />
          <EngineTypeFilter />
          <EngineCapacityFilter />
          <BatteryTypeFilter />
          <PowerReserveFilter />
          <ElectricEnginesFilter />
        </FiltersWrapper>
      </MoreParams>

      <AllParamsButton />

      <SpecialFilter />
    </React.Fragment>
  );
}
